/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/27/2016
 * Time: 3:13 PM
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const FormError = ({ message }) => {
  return <div className="form-error">
    <FormattedMessage {...message} />
  </div>;
};

FormError.propTypes = {
  message: PropTypes.any
};

export default FormError;
